export default "__VITE_PUBLIC_ASSET__ac6803d1__"